import portal from "@/lib/portalApi";

const d = (r) => r.data;
export const sec = {
  profile: () => portal.get("/profile").then(d),
  update: (body) => portal.patch("/profile", body).then(d),
  avatar: (file) => { const f = new FormData(); f.append("file", file); return portal.post("/profile/avatar", f).then(d); },
  removeAvatar: () => portal.delete("/profile/avatar").then(d),
  changePassword: (current_password, new_password) => portal.post("/profile/password", { current_password, new_password }).then(d),
  setup2fa: () => portal.post("/profile/2fa/setup").then(d),
  enable2fa: (code) => portal.post("/profile/2fa/enable", { code }).then(d),
  disable2fa: (password, code) => portal.post("/profile/2fa/disable", { password, code }).then(d),
  newBackupCodes: (code) => portal.post("/profile/2fa/backup-codes", { code }).then(d),
  revokeSessions: () => portal.post("/profile/sessions/revoke").then(d),
  activity: () => portal.get("/profile/activity").then(d),
  login2fa: (challenge, code) => portal.post("/auth/login/2fa", { challenge, code }).then(d),
  forgot: (email) => portal.post("/auth/password/forgot", { email }).then(d),
  resetCheck: (token) => portal.get(`/auth/password/reset/${encodeURIComponent(token)}`).then(d),
  reset: (token, password) => portal.post("/auth/password/reset", { token, password }).then(d),
  adminOverview: () => portal.get("/admin/users/security").then(d),
  adminAction: (id, action) => portal.post(`/admin/users/${id}/security`, { action }).then(d),
};

/** 0-4 strength score + checks shown under password fields (same rules as the server). */
export function passwordChecks(pw = "", email = "") {
  const local = (email.split("@")[0] || "").toLowerCase();
  const checks = {
    length: pw.length >= 8,
    letters: /[A-Za-z]/.test(pw) && /\d/.test(pw),
    noEmail: !(local.length >= 4 && pw.toLowerCase().includes(local)),
  };
  let score = 0;
  if (pw.length >= 8) score++;
  if (pw.length >= 12) score++;
  if (/[A-Z]/.test(pw) && /[a-z]/.test(pw)) score++;
  if (/\d/.test(pw) && /[^A-Za-z0-9]/.test(pw)) score++;
  return { checks, ok: Object.values(checks).every(Boolean), score: Math.min(4, score) };
}
